import { techTheme } from 'src/features/common/app/components/theme-provider/theme';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const StyledItemWrapper = styled(FlexBox)`
    border: 1px solid ${techTheme.colors.gs450};
    border-radius: 12px;
`;

export const StyledTitleWrapper = styled.div`
    padding: 12px 16px;
    background: ${techTheme.colors.grey800};
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    display: flex;
    align-items: center;
    gap: 10px;
`;
export const StyledWrapper = styled.div`
    margin: 32px 0;

    ${media.sm`
        margin: 48px 0 104px;
   `}
`;

export const StyledTextWrapper = styled.ul`
    padding: 24px 34px;

    & li {
        padding-bottom: 16px;

        ::marker {
            font-size: 130%;
            color: ${techTheme.colors.lightGrey};
        }
    }
`;